/*
 * Mock data for use in the client-js demo homepage
 */

/**
 * Get a secret by key from secretsFile. secrets.json is intentionally ignored to avoid leaking secrets to source
 * control.
 *
 * @param {string} key
 * @returns {string}
 */
function getSecret(key) {
  var secretsData = {};

  // Uncomment to load secrets from ./secrets.json
  // secretsData = require('./secrets.json');

  return secretsData.hasOwnProperty(key) ? secretsData[key] : 'unknown';
}

function customCodeFn() {
  var utils = window.optimizely.get('utils');
  new utils.Promise(function(resolve, reject) {
    resolve();
  }).then(function() {
    window.console.log('Ran custom code');
  }).catch();
}

function layerCustomCodeFn() {
  var utils = window.optimizely.get('utils');
  new utils.Promise(function(resolve, reject) {
    resolve();
  }).then(function() {
    window.console.log('Ran layer custom code');
  }).catch();
}

function windowChangeFn() {
  window.customChange();
}

var DATA = {
  holdback: 0,
  revision: '1',
  accountId: '1000',
  projectId: '2000',
  snippetId: '3000',
  namespace: 'TESTNS',
  projectJS: function() {
    console.log('I\'m project JS!');

    // For odp integration
    window.zaius = {
      VUID: getSecret('ODP_VUID')
    };

    (function holdEventsUntilDeferredScript() {
      window.optimizely = window.optimizely || [];
      window.optimizely.push({
        type: 'holdEvents'
      });

      function addInlineScript(timeout) {
        if (timeout) {
          return setTimeout(addInlineScript, timeout);
        }
        var scr = document.createElement('script');
        var scriptContent = 'window.optimizely = window.optimizely || []; window.optimizely.push({type: "sendEvents"});';
        scr.textContent = scriptContent;
        scr.async = true;
        document.body.appendChild(scr);
      }

      function pollForBody() {
        if (document.body) {
          addInlineScript(2500);
        } else if (typeof window.requestAnimationFrame === 'function') {
          requestAnimationFrame(pollForBody);
        } else {
          setTimeout(pollForBody, 0);
        }
      }

      pollForBody();
    })();

    (function subroutine() {
      throw new Error('Oh no!');
    }());
  },
  visitorAttributes: [
    {
      id: '456',
      dcp_datasource_id: '123',
      name: 'Named DCPDataSourceAttribute',
      datatype: 'string',
    },
    {
      id: '789',
      dcp_datasource_id: '123',
      // Name omitted as in an obfuscated project.
      //name: 'Unnamed Visitor Attribute',
      datatype: 'string',
    },
  ],
  dcpServiceId: 'fakeDcpServiceId',
  dcpKeyfieldLocators: [
    {
      dcp_datasource_id: '456',
      is_optimizely: true,
      name: 'Optimizely',
      type: 'string',
    },
  ],
  audiences: [
    {
      id: '100',
      name: 'browser_gc',
      conditions: ['and', {type: 'browser_version', value: 'gc'}]
    },
    {
      // condition: ['and', {type: 'browser', value: 'ff'}, {type: 'platform', value: 'mac os'}]
      id: '101',
      name: 'cookie_a',
      conditions: ['and', {type: 'cookies', name: 'a', value: 'true'}]
    },
      {
          'conditions': [
              'and',
              [
                  'or',
                  [
                      'or',
                      {
                          'value': 'has_email',
                          'type': 'vendor.odp',
                          'name': 'audiences',
                          'match': null
                      },
                      {
                          'value': 'MVP_Customers',
                          'type': 'vendor.odp',
                          'name': 'audiences',
                          'match': null
                      }
                  ],
                  [
                      'or',
                      {
                          'value': 'edge',
                          'type': 'browser_version',
                          'name': null,
                          'match': null
                      }
                  ]
              ]
          ],
          'id': '6370430283',
          'name': null
      },
      {
          'conditions': [
              'and',
              [
                  'or',
                  [
                      'or',
                      {
                          'value': 'has_phone',
                          'type': 'vendor.odp',
                          'name': 'audiences',
                          'match': null
                      }
                  ]
              ]
          ],
          'id': '6419830061',
          'name': null
      },
    {
      id: '102',
      name: 'cookie_b',
      conditions: ['and', {type: 'cookies', name: 'b', value: 'true'}]
    },
    {
      id: '103',
      name: 'cookie_a_b',
      conditions: ['and', ['or', {type: 'cookies', name: 'a', value: 'false'}, {
        type: 'cookies',
        name: 'b',
        value: 'true'
      }]]
    },
    {
      id: '104',
      name: 'cookie_new_visitor_exists',
      conditions: ['and', {type: 'cookies', name: 'new_visitor', match_type: 'exists'}],
    },
    {
      id: '105',
      name: 'meta_jeans',
      conditions: ['and', {
        type: 'behavior', value: JSON.stringify({
          where: ['and',
            ['or',
              {
                op: 'eq',
                args: [{
                  field: ['metadata', 'type']
                }, {
                  value: 'jeans'
                }]
              }
            ]
          ]
        }),
      }]
    },
    {
      id: '107',
      name: 'ipAddrExact',
      conditions: ['and', {type: 'ip', value: '198.151.206.196'}]
    },
    {
      id: '108',
      name: 'ipAddrCIDR',
      conditions: ['and', {type: 'ip', value: '198.151.0.0/16', match: 'cidr'}]
    },
    {
      id: '109',
      name: 'geoNA',
      conditions: ['and', {type: 'location', value: '|||NA'}]
    },
    {
      id: '110',
      name: 'geoCity',
      conditions: ['and', {type: 'location', value: 'US|CA|SANFRANCISCO|NA'}]
    },
    {
      id: '111',
      name: 'geoEur',
      conditions: ['and', {type: 'location', value: '|||EU'}]
    },
    {
      id: '112',
      name: 'Weekdays',
      conditions: ['and', {type: 'time_and_day', value: '08:00_17:00_monday,tuesday,wednesday,thursday,friday'}],
    },
    {
      id: '113',
      name: 'Weekend',
      conditions: ['and', {type: 'time_and_day', value: '00:00_23:59_saturday,sunday'}],
    },
    {
      id: '114',
      name: 'demandbaseOpt',
      conditions: ['and', {type: 'vendor.demandbase', name: 'company_name', value: 'Optimizely'}],
    },
    {
      id: '115',
      name: 'krux chrome',
      // "Chrome users" segment
      conditions: ['and', {type: 'vendor.krux', name: 'audiences', value: 'pgvl2f2tv'}],
    },
    {
      id: '116',
      name: 'skymosity normal',
      conditions: [
        'and',
        [
          'or',
          [
            'or',
            {
              'type': 'vendor.skymosity',
              'name': 'currentTemperature',
              'value': '60:120',
              'match': 'range',
            }
          ]
        ]
      ],
    },
    {
      id: '117',
      name: 'custom dimensions',
      conditions: [
        'and',
        {
          type: 'custom_dimension',
          // Real dimension has ID
          name: '156423'
        },
        [
          'not',
          {
            type: 'custom_dimension',
            name: 'dimension2',
            value: 'true',
          },
        ],
      ],
    },
    {
      id: '118',
      name: 'geo!NA',
      conditions: ['and', ['not', {type: 'location', value: '|||NA'}]],
    },
    {
      id: '119',
      name: 'multiple-async-and',
      conditions: ['and', {type: 'location', value: '|||NA'}, {type: 'list', name: 'missinglist'}],
    },
    {
      id: '120',
      name: 'multiple-async-or',
      conditions: ['or', {type: 'location', value: '|||NA'}, {type: 'list', name: 'missinglist'}],
    },
    {
      id: 'redir',
      name: 'redir',
      conditions: ['or', {type: 'query', name: 'redir', value: 'true'}],
    },
  ],
  integrationSettings: [
    {
      id: 'demandbase',
      cbParam: 'callback',
      dataFetchMethod: 'callout',
      url: 'https://api.demandbase.com/api/v3/ip.json?key=' + getSecret('DEMANDBASE_API_KEY'),
    },
    {
      id: 'skymosity',
      cbParam: 'callback',
      dataFetchMethod: 'callout',
      url: 'https://optimizely.skymosity.com/sp.js',
    },
    {
      id: 'mixpanel',
    },
    {
      id: 'odp',
      public_key: getSecret('ODP_PUBLIC_KEY'),
      host: '//api.zaius.com',
    },
  ],
  events: [
    {
      id: 'new',
      category: 'add_to_cart',
      pageId: '1',
      eventType: 'click',
      apiName: 'laurenapiname',
      name: 'laurenname',
      eventFilter: {
        filterType: 'target_selector',
        selector: 'a',
      }
    },
    {
      id: '1',
      category: 'add_to_cart',
      pageId: '2',
      name: 'Add to cart click',
      apiName: 'my_add_to_cart',
      eventType: 'click',
      eventFilter: {
        filterType: 'target_selector',
        selector: '#add-to-cart',
      }
    },
    {
      id: '2',
      pageId: '1',
      name: 'Nav click',
      apiName: 'nav_bar_click',
      category: 'search',
      eventType: 'click',
      eventFilter: {
        filterType: 'target_selector',
        selector: '#nav',
      }
    },
    {
      id: '3',
      category: 'add_to_cart',
      pageId: '3',
      name: 'Add to cart click',
      apiName: 'sidebar_add_to_cart',
      eventType: 'click',
      eventFilter: {
        filterType: 'target_selector',
        selector: '#add-to-cart',
      }
    },
    {
      id: '4',
      pageId: '1',
      name: 'User scroll',
      apiName: 'scroll_search',
      category: 'search',
      eventType: 'custom',
      eventFilter: null,
    }
  ],
  dimensions: [
    {
      segmentId: 'dimension_1_segment_id',
      id: 'dimension_1_id',
      apiName: 'dimension1',
      name: 'Custom Dimension 1',
    },
    {
      segmentId: null,
      id: 'custom_attr1_id',
      apiName: 'custom_attr1',
      name: 'Custom Attribute 1',
    },
  ],
  changes: [
    {
      id: '1000_20_10_1',
      type: 'attribute',
      attributes: {
        text: 'Changed after click',
      },
      selector: '#nonExistent',
      dependencies: [],
    },
    {
      id: '1000_20_11_1',
      type: 'attribute',
      attributes: {
        text: 'Changed after click',
      },
      selector: '#nonExistent',
      dependencies: [],
    },
    {
      id: '1001_4_12_2_1',
      type: 'attribute',
      attributes: {
        text: 'Changed after click',
      },
      selector: '#nonExistent',
      dependencies: [],
    },
    {
      id: '1001_4_13_2',
      type: 'attribute',
      attributes: {
        text: 'Changed after click',
      },
      selector: '#nonExistent',
      dependencies: [],
    },
    {
      id: 'layerChange1',
      type: 'append',
      selector: 'head',
      value: '\<style\>#toChange {\ncolor: red;\n}\n</style>',
      dependencies: []
    },
    {
      id: 'layerChange2',
      type: 'custom_code',
      value: layerCustomCodeFn,
      dependencies: []
    },
    {
      id: '1002_30_33_1',
      type: 'attribute',
      attributes: {
        text: 'Changed after click',
      },
      selector: '#nonExistent',
      dependencies: [],
    },
    {
      id: '1003_33_18_3-1',
      type: 'attribute',
      attributes: {
        text: 'Changed after click',
      },
      selector: '#toChangeOnClick',
      dependencies: [],
    },
    {
      id: '1003_33_18_3-2',
      type: 'custom_code',
      value: windowChangeFn,
      dependencies: [],
    },
  ],
  layers: [
    {
      id: '1000',
      name: 'ab_view1',
      commitId: '123',
      holdback: 500,
      policy: 'random',
      viewIds: ['1'],
      integrationStringVersion: 1,
      experiments: [{
        id: '20',
        audienceIds: ['101'],
        variations: [{
          id: '10',
          actions: [
            {
              pageId: '1',
              changes: ['1000_20_10_1'],
            },
          ],
        },
        {
          id: '11',
          actions: [
            {
              pageId: '1',
              changes: ['1000_20_11_1'],
            }
          ],
        }],
        weightDistributions: [{
          entityId: '10',
          endOfRange: 5000,
        }, {
          entityId: '11',
          endOfRange: 10000,
        }],
      }],
    },
    {
      id: '1001',
      name: 'mutex_view2',
      commitId: '234',
      holdback: 500,
      policy: 'random',
      viewIds: ['2'],
      integrationStringVersion: 1,
      experiments: [
        {
          id: '4',
          name: 'mutex_view2_exp1',
          audienceIds: ['100', '101'],
          variations: [
            {
              id: '12',
              name: 'mutex_view2_exp1_var1',
              actions: [
                {
                  pageId: '2',
                  changes: ['1001_4_12_2_1'],
                }
              ],
            },
            {
              id: '13',
              name: 'mutex_view2_exp1_var2',
              actions: [
                {
                  pageId: '2',
                  changes: ['1001_4_13_2'],
                }
              ],
            }
          ],
          weightDistributions: [{
            entityId: '12',
            endOfRange: 4000,
          }, {
            entityId: '13',
            endOfRange: 10000,
          }]
        },
        {
          id: '5',
          name: 'mutex_view2_exp2',
          audienceIds: ['100', '103'],
          variations: [{
            id: '14',
            name: 'mutex_view2_exp2_var1',
            actions: [
              {
                pageId: '2',
                changes: [
                  {
                    id: '1',
                    type: 'attribute',
                    attributes: {
                      text: 'Changed after click',
                    },
                    selector: '#nonExistent',
                    dependencies: [],
                  }
                ],
              },
            ],
          }],
        },
      ],
      weightDistributions: [{
        entityId: '21',
        endOfRange: 3000,
      }, {
        entityId: '5',
        endOfRange: 10000,
      }],
    },
    {
      id: '1002',
      name: 'ordered_view1_2_3',
      commitId: '345',
      changes: ['layerChange1', 'layerChange2'],
      holdback: 1000,
      policy: 'ordered',
      activation: {
        type: 'timeout',
        timeout: 300,
      },
      viewIds: ['1', '2', '3'],
      integrationStringVersion: 1,
      experiments: [{
        id: '30',
        name: 'ordered_view1_2_3_exp1',
        audienceIds: ['102'],
        variations: [{
          id: '33',
          name: 'ordered_view1_2_3_exp1_var1',
          actions: [
            {
              pageId: '1',
              changes: ['1002_30_33_1'],
            }
          ],
        }]
      }, {
        id: '31',
        name: 'ordered_view1_2_3_exp2',
        audienceIds: ['101'],
        variations: [{
          id: '34',
          name: 'ordered_view1_2_3_exp2_var1',
          actions: [
            {
              pageId: '1',
              changes: [
                {
                  id: '1',
                  type: 'attribute',
                  attributes: {
                    text: 'Changed after click',
                  },
                  selector: '#nonExistent',
                  dependencies: [],
                }
              ],
            }
          ],
        }]
      }, {
        id: '32',
        name: 'ordered_view1_2_3_exp3',
        variations: [{
          id: '35',
          name: 'ordered_view1_2_3_exp3_var1',
          actions: [
            {
              pageId: '2',
              changes: [
                {
                  id: '1',
                  type: 'attribute',
                  attributes: {
                    text: 'Changed',
                  },
                  selector: '#toChange',
                  dependencies: [],
                },
                {
                  id: '2',
                  type: 'custom_code',
                  value: customCodeFn,
                  dependencies: [],
                },
              ],
            },
            {
              pageId: '3',
              changes: [
                {
                  id: '1',
                  type: 'attribute',
                  attributes: {
                    text: 'Changed after click',
                  },
                  selector: '#toChangeOnClick',
                  dependencies: [],
                }
              ],
            }
          ]
        }]
      }]
    },
    {
      id: '1003',
      name: 'dynamic_view3',
      commitId: null,
      policy: 'random',
      holdback: 0,
      activation: {
        type: 'manual',
      },
      viewIds: ['3'],
      integrationStringVersion: 1,
      experiments: [{
        id: '33',
        name: 'dynamic_view3_exp1',
        variations: [{
          id: '18',
          name: 'dynamic_view3_exp1_var1',
          actions: [
            {
              pageId: '3',
              changes: [
                '1003_33_18_3-1',
                '1003_33_18_3-2',
              ],
            }
          ],
        }]
      }]
    },
    {
      id: '1004',
      name: 'IP layer',
      policy: 'ordered',
      holdback: 0,
      viewIds: ['2'],
      integrationStringVersion: 1,
      experiments: [
        {
          id: 'ip_exp_1',
          audienceIds: ['107'],
          variations: [
            {
              id: 'ip_exp_1_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: 'ip_exp_1_change',
                      type: 'custom_code',
                      value: customCodeFn,
                      dependencies: [],
                    }
                  ],
                }
              ]
            }
          ]
        },
        {
          id: 'ip_exp_2',
          audienceIds: ['108'],
          variations: [
            {
              id: 'ip_exp_2_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: 'ip_exp_2_change',
                      type: 'custom_code',
                      value: customCodeFn,
                      dependencies: [],
                    }
                  ],
                }
              ]
            }
          ]
        },
        {
          id: 'ip_exp_3',
          variations: [
            {
              id: 'ip_exp_3_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: 'ip_exp_3_change',
                      type: 'custom_code',
                      value: customCodeFn,
                      dependencies: [],
                    }
                  ],
                }
              ]
            }
          ]
        }
      ]

    },
    {
      id: '1005',
      name: 'Geo region',
      holdback: 0,
      policy: 'ordered',
      viewIds: ['2'],
      integrationStringVersion: 1,
      experiments: [
        {
          id: 'geo_exp_1',
          name: 'geo NA',
          audienceIds: ['109'],
          variations: [
            {
              id: 'geo_exp_1_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: '1',
                      type: 'attribute',
                      attributes: {
                        text: 'IN',
                      },
                      selector: '#geo-region',
                      dependencies: [],
                    },
                    {
                      id: '2',
                      type: 'attribute',
                      attributes: {
                        style: 'display: inline',
                      },
                      selector: '#geo-hide',
                      dependencies: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 'geo_exp_2',
          name: 'geo not NA',
          audienceIds: ['118'],
          variations: [
            {
              id: 'geo_exp_2_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: '1',
                      type: 'attribute',
                      attributes: {
                        text: 'NOT IN',
                      },
                      selector: '#geo-region',
                      dependencies: [],
                    },
                    {
                      id: '2',
                      type: 'attribute',
                      attributes: {
                        style: 'display: inline',
                      },
                      selector: '#geo-hide',
                      dependencies: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 'geo_exp_3',
          name: 'geo unknown',
          variations: [
            {
              id: 'geo_exp_3_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: '1',
                      type: 'attribute',
                      attributes: {
                        text: '???',
                      },
                      selector: '#geo-region',
                      dependencies: [],
                    },
                    {
                      id: '2',
                      type: 'attribute',
                      attributes: {
                        style: 'display: inline',
                      },
                      selector: '#geo-hide',
                      dependencies: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: '1006',
      name: 'Async AND',
      holdback: 0,
      policy: 'ordered',
      viewIds: ['2'],
      integrationStringVersion: 1,
      experiments: [
        {
          id: 'async_and_1',
          name: 'Async AND YES',
          audienceIds: ['119'],
          variations: [
            {
              id: 'async_and_exp_1_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: '1',
                      type: 'attribute',
                      attributes: {
                        text: 'YES',
                      },
                      selector: '#multiple-and',
                      dependencies: [],
                    },
                    {
                      id: '2',
                      type: 'attribute',
                      attributes: {
                        style: 'display: inline',
                      },
                      selector: '#multiple-and-hide',
                      dependencies: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 'async_and_2',
          name: 'Async AND NO',
          variations: [
            {
              id: 'async_and_exp_2_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: '1',
                      type: 'attribute',
                      attributes: {
                        text: 'NO',
                      },
                      selector: '#multiple-and',
                      dependencies: [],
                    },
                    {
                      id: '2',
                      type: 'attribute',
                      attributes: {
                        style: 'display: inline',
                      },
                      selector: '#multiple-and-hide',
                      dependencies: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: '1007',
      name: 'Async OR',
      holdback: 0,
      policy: 'ordered',
      viewIds: ['2'],
      integrationStringVersion: 1,
      experiments: [
        {
          id: 'async_or_1',
          name: 'Async OR YES',
          audienceIds: ['120'],
          variations: [
            {
              id: 'async_or_exp_1_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: '1',
                      type: 'attribute',
                      attributes: {
                        text: 'YES',
                      },
                      selector: '#multiple-or',
                      dependencies: [],
                    },
                    {
                      id: '2',
                      type: 'attribute',
                      attributes: {
                        style: 'display: inline',
                      },
                      selector: '#multiple-or-hide',
                      dependencies: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 'async_or_2',
          name: 'Async OR NO',
          variations: [
            {
              id: 'async_or_exp_2_var_1',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: '1',
                      type: 'attribute',
                      attributes: {
                        text: 'NO',
                      },
                      selector: '#multiple-or',
                      dependencies: [],
                    },
                    {
                      id: '2',
                      type: 'attribute',
                      attributes: {
                        style: 'display: inline',
                      },
                      selector: '#multiple-or-hide',
                      dependencies: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: '10008',
      name: 'single_exp',
      holdback: 2000,
      viewIds: ['1', '2', '3'],
      integrationStringVersion: 1,
      experiments: [
        {
          weightDistributions: [
            {
              entityId: 'var1',
              endOfRange: 5000
            },
            {
              entityId: 'var2',
              endOfRange: 10000
            }
          ],
          audienceName: 'chrome',
          name: 'single_exp',
          variations: [
            {
              id: 'var1',
              actions: [
                {
                  pageId: '1',
                  changes: [
                    {
                      id: '1',
                      selector: '#toChange',
                      attributes: {
                        html: 'Unchanged  Original!!'
                      },
                      type: 'attribute',
                    }
                  ]
                }
              ],
              name: 'Original',
            },
            {
              id: 'var2',
              actions: [
                {
                  pageId: '1',
                  changes: [
                    {
                      id: '1',
                      selector: '#toChange',
                      attributes: {
                        html: 'Unchanged Variation 1!'
                      },
                      type: 'attribute',
                    }
                  ]
                }
              ],
              name: 'Variation #1',
            }
          ],
          audienceIds: ['100'],
          changes: null,
          id: '888',
          integrationSettings: null
        }
      ],
      weightDistributions: null,
      decisionMetadata: null,
      policy: 'single_experiment',
    },
    {
      id: 'redirect',
      policy: 'single_experiment',
      holdback: 0,
      integrationSettings: {
        mixpanel: true,
      },
      viewIds: ['2'],
      integrationStringVersion: 1,
      experiments: [
        {
          id: 'redirect_exp',
          audienceIds: ['redir'],
          variations: [
            {
              id: 'redirect_exp_var',
              actions: [
                {
                  pageId: '2',
                  changes: [
                    {
                      id: 'redirect_change',
                      type: 'redirect',
                      dest: '/page2.html',
                      preserveParameters: true,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  listTargetingCookies: ['cookie1', 'optimizelyEndUserId'],
  views: [
    {
      id: '1',
      name: 'myViewOne',
      apiName: 'home',
      category: 'home',
      eventFilter: null,
      staticConditions: [],
      tags: [],
    },
    {
      id: '2',
      name: 'viewTwo',
      apiName: 'index',
      category: 'other',
      staticConditions: ['and', ['not', {type: 'url', value: 'page2', match: 'substring'}]],
      eventFilter: null,
      tags: [
        {
          apiName: 'price',
          category: 'price',
          locator: '.item-price',
          locatorType: 'css_selector',
          valueType: 'currency',
        },
        {
          apiName: 'name',
          category: 'name',
          locator: '.item-name',
          locatorType: 'css_selector',
          valueType: 'string',
        },
      ],
    },
    {
      id: '3',
      apiName: 'home',
      category: 'home',
      staticConditions: ['and', {type: 'url', value: '.*', match: 'regex'}],
      eventType: 'click',
      eventFilter: {
        filterType: 'target_selector',
        selector: '#clickEventButton',
      },
    },
    {
      id: '4',
      name: 'viewFour',
      apiName: 'page2',
      category: 'other',
      staticConditions: ['and', {type: 'url', value: 'page2', match: 'substring'}],
      eventFilter: null,
    },
    {
      id: '5',
      name: 'domTriggerViewImmediate',
      apiName: 'dtvi',
      category: 'other',
      activationType: 'dom_changed',
      // Allows us to test delayed activation by adding "dom" to the hash after page load
      staticConditions: [{type: 'url', value: 'dom', match: 'substring'}],
    },
    {
      id: '6',
      name: 'urlTriggerViewImmediate',
      apiName: 'utvi',
      category: 'other',
      activationType: 'url_changed',
      // Allows us to test delayed activation by adding "url" to the hash after page load
      staticConditions: [{type: 'url', value: 'url', match: 'substring'}],
    },
  ],
};

module.exports = DATA;
